import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popup from '../controls/Popup';
import { PopupBody, PopupFooter } from '../controls';
import { Checkbox } from '../controls/Checkbox';
import { portfolioAgreementDisclaimerActions } from '../../actions/portfolio-agreement-disclaimer.actions';
import { PortfolioAgreementDisclaimerText } from './PortfolioAgreementDisclaimerText';
import { AppState } from '../../types/state/AppState';
import { isRequesting } from '../../utils';
import IconSVG from '../../styles/svg-icons';

export const PortfolioAgreementDisclaimerPopup: React.FC = () => {
    const dispatch = useDispatch();

    const [agreeCheckBoxChecked, setAgreeCheckBoxChecked] = useState(false);
    const downloadFilefRequestState = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.downloadFileRequestState);
    const confirmRequestState = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.confirmRequestState);
    const visible = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.visible);
    const agreeButtonText = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.agreeButtonText);


    useEffect(() => {
        if (!visible) {
            setAgreeCheckBoxChecked(false);
        }
    }, [visible]);

    if (!visible) {
        return null;
    }

    const handleOnClose = () => {
        dispatch(portfolioAgreementDisclaimerActions.hide(false))
    };

    return (
        <Popup
            title="Portfolio Disclaimer"
            modalClass="modal-portfolio-user-agreement"
            onClose={handleOnClose}
        >
            <PopupBody>
                <div className="disclaimer">
                    <PortfolioAgreementDisclaimerText />
                    <div className="row">
                        <button
                            className="btn-link"
                            onClick={() => dispatch(portfolioAgreementDisclaimerActions.downloadFileRequest())}
                            disabled={isRequesting(downloadFilefRequestState)}
                        >
                            <IconSVG name="downloadTemplate" width={16} height={16} /> Download agreement
                        </button>
                    </div>
                    <div className="row">
                        <Checkbox
                            label="I agree to terms and conditions"
                            checked={agreeCheckBoxChecked}
                            onChange={() => setAgreeCheckBoxChecked(!agreeCheckBoxChecked)}
                        />
                    </div>
                </div>
            </PopupBody>
            <PopupFooter>
                <button
                    className="btn btn-main"
                    onClick={() => dispatch(portfolioAgreementDisclaimerActions.confirmRequest())}
                    disabled={!agreeCheckBoxChecked || isRequesting(confirmRequestState)}
                >
                    {
                        agreeButtonText === 'Next'
                            ? <>{agreeButtonText} <IconSVG name="icon-expand" width={16} height={16} /></>
                            : agreeButtonText
                    }
                </button>
            </PopupFooter>
        </Popup>
    )
};
